import { FC } from "react";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { dayNames, TrainingDay } from "@/app/training/training-day";

export type MoveTabEventHandler = (trainingDay: TrainingDay) => void;
export type DayChangeEventHandler = (trainingDay: TrainingDay) => void;

export type RoutineTabsProps = {
  onMoveLeft: MoveTabEventHandler;
  onMoveRight: MoveTabEventHandler;
  onDayChange: DayChangeEventHandler;
  days: Array<TrainingDay>;
  currentDay: TrainingDay;
  button?: React.ReactNode;
};

// Mapeo de abreviaturas a nombres completos

const RoutineTabs: FC<RoutineTabsProps> = ({
  onMoveLeft,
  onMoveRight,
  currentDay,
  onDayChange,
  days,
  button,
}) => {
  // Calculamos el índice del día actual en el array days
  const currentIndex = days.indexOf(currentDay);

  return (
    <div className="">
      <div className="flex-1">
        {/* Tabs para pantallas pequeñas */}
        <div className="md:hidden mt-12">
          <label htmlFor="tabs" className="sr-only">
            Select a tab
          </label>
          <select
            id="tabs"
            name="tabs"
            value={currentDay}
            onChange={(event) => onDayChange(event.target.value as TrainingDay)}
            className="block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
          >
            {days.map((day) => (
              <option key={day} value={day}>
                {dayNames[day]} {/* Mostramos el nombre completo */}
              </option>
            ))}
          </select>
        </div>

        {/* Mostrar botón debajo de los tabs en pantallas pequeñas */}
        <div className="md:hidden mt-4">{button && <div>{button}</div>}</div>

        {/* Tabs para pantallas grandes */}
        <div className="hidden md:flex justify-between items-center border-b border-gray-200 mt-10">
          {/* Contenedor de los tabs */}
          <nav aria-label="Tabs" className="-mb-px flex space-x-8">
            {days.map((day) => (
              <div key={day} className="flex items-center">
                {/* Flecha izquierda: solo si no estamos en el primer día */}
                {day === currentDay && currentIndex > 0 && (
                  <button
                    className="text-indigo-600 mr-2"
                    onClick={() => onMoveLeft(day)}
                  >
                    <FontAwesomeIcon icon={faChevronLeft} />
                  </button>
                )}

                {/* Botón del día con el nombre completo */}
                <button
                  onClick={() => onDayChange(day)}
                  className={`whitespace-nowrap border-b-2 px-2 py-4 text-sm font-medium ${
                    currentDay === day
                      ? "border-indigo-500 text-primary-600"
                      : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700"
                  }`}
                >
                  {dayNames[day]} {/* Mostramos el nombre completo */}
                </button>

                {/* Flecha derecha: solo si no estamos en el último día */}
                {day === currentDay && currentIndex < days.length - 1 && (
                  <button
                    className="text-primary-600"
                    onClick={() => onMoveRight(day)}
                  >
                    <FontAwesomeIcon icon={faChevronRight} />
                  </button>
                )}
              </div>
            ))}
          </nav>
          {button && <div className="ml-auto">{button}</div>}
        </div>
      </div>
    </div>
  );
};

export default RoutineTabs;
